import {Route, Routes} from "react-router-dom";
import Blacklists from "../Pages/Blacklist/Blacklists";
import BuildersLanding from "../Pages/Builders/BuildersLanding";
import Comparison from "../Pages/Comparison/Comparison";
import ETFMatrix from "../Pages/EtfMatrix/EtfMatrix";
import FactSheet from "../Pages/Portfolio/FactSheet/FactSheet";
import Files from "../Pages/Files/Files";
import {default as PortfolioFormBuilder} from "../Pages/FormBuilder/FormBuilder";
import IAPlatformAppHome from "../Layouts/IAPlatform/IAPlatformHome";
import IQPlatformHome from "../Layouts/IQPlatform/IQPlatformHome";
import PerformanceComparison from "../Pages/PerformanceComparison/PerformanceComaprison";
import PortfolioBuilder from "../SuperComponents/PortfolioBuilder/PortfolioBuilder";
import PortfolioCollection from "../Pages/Portfolio/PortfolioCollection";
import PortfolioPages  from "../Pages/Portfolio/PortfolioPages/PortfolioPages";
import PortfolioPagePublicEntrypoint from "../Pages/PublicPages/PortfolioPagePublicEntrypoint";
import PortfolioSignals from "../Pages/TradingSignals/components/PortfolioSignals";
import PortfolioView from "../Pages/PortfolioView/PortfolioView";
import Prospects from "../Pages/Prospects/Prospects";
import Screens from "../Pages/Screens/Screens";
import Settings from "../Pages/Settings/Settings";
import SMALab from "../Pages/SmaLab/SmaLab";
import SuperUser from "../Pages/SuperUser/SuperUser";
import Touchpoints from "../Pages/Touchpoints/Touchpoints";
import TradingSignals from "../Pages/TradingSignals/TradingSignals";
import Snapshots from "../Pages/TradingSignals/Snapshots/Snapshots";
import TickerView    from "../Pages/TickerView/TickerView";
import React from "react";


import CompanyDetailsForm from "../Pages/Company/CompanyDetailsForm";
import Goals from "../Pages/Goals/Goals";
import ScenarioSimulation from "../SuperComponents/Simulations/Simulation";
import DataFetchingComponent from "../SuperComponents/Beta/DemoLargeDataApi";
import RankFeatures from "../SuperComponents/LdaViews/RankFeatures";

import IncomeModel from "../Pages/IncomeModel/IncomeModel";
import ClientJourney from "../SuperComponents/ClientJourney/ClientJourney";
import GeneralStockChart from "../SuperComponents/StockCharts/GeneralStockChart";
import AttributionModel from "../SuperComponents/Beta/AttributionModel";

export const PublicRoutes = () => {
    return (
            <Routes>
                {/* Define public routes here */}
                <Route path="/public/portfolio/:portfolioId" element={<PortfolioView/>}/>
                <Route path="/public/etfs/matrix" exact element={<ETFMatrix/>}/>
                <Route path={'/public/pages/:pageId'} element={<PortfolioPagePublicEntrypoint/>} />
                <Route path={'/public/etf-matrix'} element={<ETFMatrix/>}/>

                {/* You can add more public routes as needed */}
            </Routes>
    )
}


export const IAPlatformRoutes = ({widgets}) => {
    return (
        <Routes>
            <Route path="/"  exact element={<IAPlatformAppHome widgets={widgets} />} />
            <Route path={'/beta/gam'} exact element={<DataFetchingComponent/>}/>
            <Route path="/builders/landing" exact element={<BuildersLanding />} />
            <Route path="/builders/portfolio" exact element={<PortfolioBuilder />} />
            <Route path="/builders/model" exact element={<PortfolioFormBuilder />} />
            <Route path="/builders/sma" exact element={<SMALab />} />


            <Route path={"/company/details/edit"} exact element={<CompanyDetailsForm/>} />
            <Route path="/etfs/matrix" exact element={<ETFMatrix />} />

            <Route path="/files" exact element={<Files/>} />

            <Route path="/goals" exact element={<Goals />} />

            <Route path={'/models/income/:portfolioId'} exact element={<IncomeModel/>} />

            <Route path="/pages" exact element={<PortfolioPages />} />
            <Route path="/portfolios" element={<PortfolioCollection />} />
            <Route path="/portfolio/:portfolioId" element={<PortfolioView />} />
            <Route path="/portfolio/:portfolioId/factsheet" element={<FactSheet />} />

            <Route path="/signals" exact element={<TradingSignals />} />
            <Route path="/signals/:portfolioId" element={<PortfolioSignals />} />
            <Route path="/signals/:portfolioId/history" element={<Snapshots />} />

            <Route path="/performance/comparison" exact element={<PerformanceComparison />} />


            <Route path="/screener" exact element={<Screens />} />

            <Route path="/prospects" exact element={<Prospects />} />
            <Route path="/widgets/blacklist" exact element={<Blacklists />} />

            <Route path="/settings" exact element={<Settings />} />
            <Route path="/superuser" exact element={<SuperUser />} />
            <Route path={'/beta/touchpoints'} exact element={<Touchpoints />} />
            <Route path={'/beta/simulate'} exact element={<ScenarioSimulation/>} />
            <Route path={'/beta/rank-features'} exact element={<RankFeatures/>} />
            <Route path={'/beta/comparison'} exact element={<Comparison/>} />
            <Route path={'/beta/journey'} exact element={<ClientJourney/>} />
            <Route path={'/beta/general/chart'} exact element={<GeneralStockChart/>} />
            <Route path="/tickers/:ticker" exact element={<TickerView/>} />
             <Route path="/beta/attribution" element={<AttributionModel />} />
            {/* Define other routes as needed */}
        </Routes>
    )
};


export const IQPlatformRoutes = ({widgets}) => {
    return (
        <Routes>
            <Route path="/"  exact element={<IQPlatformHome widgets={widgets} />} />
            <Route path="/portfolios" element={<PortfolioCollection forceCardView={true} />} />
            <Route path="/portfolio/:portfolioId" element={<PortfolioView />} />
            <Route path={'/settings'} element={<Settings/>} />

        </Routes>

    )
}